module.exports = __webpack_public_path__ + "media/images/recipes/vega_avocado_burger-fdacfb5b3add0abea6f3ba896b88326c.pdf";